import React from 'react';
import styled from 'styled-components';

interface NavigationProps {
  onScroll: (direction: 'up' | 'down') => void;
}

const NavigationContainer = styled.div`
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  gap: 2rem;
  align-items: center;
`;

const NavButton = styled.button<{ direction: 'left' | 'right' }>`
  width: 60px;
  height: 60px;
  border: 2px solid #00ff88;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, #00ff88, #00cc6a);
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 50%;
  }
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 0 30px #00ff88;
    
    &::before {
      opacity: 0.2;
    }
    
    .arrow {
      color: #00ff88;
    }
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  .arrow {
    color: #fff;
    font-size: 1.5rem;
    font-weight: bold;
    transition: color 0.3s ease;
    z-index: 1;
  }
  
  .label {
    position: absolute;
    color: #fff;
    font-size: 0.8rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1px;
    white-space: nowrap;
    transition: all 0.3s ease;
    z-index: 1;
    
    ${props => props.direction === 'left' ? 'right: 80px;' : 'left: 80px;'}
  }
  
  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    
    .arrow {
      font-size: 1.2rem;
    }
    
    .label {
      font-size: 0.7rem;
      ${props => props.direction === 'left' ? 'right: 70px;' : 'left: 70px;'}
    }
  }
`;

const MenuButton = styled.button`
  position: fixed;
  top: 2rem;
  right: 2rem;
  width: 50px;
  height: 50px;
  border: 2px solid #00ff88;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1000;
  
  &:hover {
    background: rgba(0, 255, 136, 0.1);
    box-shadow: 0 0 20px #00ff88;
  }
  
  .hamburger {
    display: flex;
    flex-direction: column;
    gap: 4px;
    
    .line {
      width: 20px;
      height: 2px;
      background: #00ff88;
      transition: all 0.3s ease;
    }
  }
  
  @media (max-width: 768px) {
    top: 1rem;
    right: 1rem;
    width: 40px;
    height: 40px;
    
    .hamburger .line {
      width: 16px;
      height: 2px;
    }
  }
`;

const Navigation: React.FC<NavigationProps> = ({ onScroll }) => {
  return (
    <>
      <NavigationContainer>
        <NavButton 
          direction="left" 
          onClick={() => onScroll('up')}
          aria-label="Previous section"
        >
          <span className="arrow">←</span>
          <span className="label">Prev</span>
        </NavButton>
        
        <NavButton 
          direction="right" 
          onClick={() => onScroll('down')}
          aria-label="Next section"
        >
          <span className="arrow">→</span>
          <span className="label">Next</span>
        </NavButton>
      </NavigationContainer>
      
      <MenuButton aria-label="Menu">
        <div className="hamburger">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </MenuButton>
    </>
  );
};

export default Navigation;
